import { jsx as _jsx } from "react/jsx-runtime";
import { useStepperControl } from "@/hooks/useStepperControl";
import { useEffect, useMemo } from "react";
import { Processo } from "../processo";
import { UserData } from "../userdata";
export function Home() {
    var _a = useStepperControl(), activeStep = _a.activeStep, moveThroughStep = _a.moveThroughStep;
    var steps = useMemo(function () {
        return [
            {
                title: "Cadastro",
                component: UserData,
            },
            {
                title: "Cadastro",
                component: Processo,
            },
        ];
    }, []);
    useEffect(function () {
        if (!activeStep || activeStep > steps.length - 1) {
            moveThroughStep(0);
        }
    }, [activeStep]);
    if (typeof activeStep === "boolean") {
        return null;
    }
    var Step = steps[activeStep].component;
    return _jsx(Step, {});
}
